<template>
    <div>
        <residential-canteen-form :entity-id="entityId">
        </residential-canteen-form>
    </div>
</template>

<script>
import residentialCanteenForm from '@/components/pages/residentialCanteens/Form'
import dirtyForm from '@/components/mixins/dirtyForm'

export default {
    components: {
        residentialCanteenForm,
    },
    mixins: [dirtyForm],

    data() {
        return {
            entityId: null,
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler(route) {
                this.entityId = route.params.entityId
            },
        },
    },
}
</script>
